<template>
  <div class="home" :style="style">
    <div class="home__content">
      <div class="home__client">
        <img
          class="home__client-image"
          v-if="clientLogo"
          :src="clientLogo"
          :alt="title"
        />
        <div class="home__client-title" v-else v-text="title" />
      </div>
      <ul class="home__navigation-items">
        <li
          class="home__navigation-item"
          v-for="option in options"
          :key="option.type"
        >
          <cta
            v-text="translate(option)"
            @click.prevent="onSelect(option.type)"
          />
        </li>
      </ul>
    </div>
    <div v-if="brandLogo" class="home__footer">
      <img class="footer-logo" :src="brandLogo" alt="Logo" />
    </div>
  </div>
</template>

<script>
import Cta from "../components/Cta";
import logo from "../assets/logo.svg";
import { PRICE_LIST_TYPE_ENUM } from "../common/vo/PriceListTypeEnum";

export default {
  name: "HomeModule",

  components: {
    Cta,
  },

  props: {
    title: { type: String },
    options: { type: Array },
    backgroundColor: { type: String },
    clientLogo: { type: String },
    brandLogo: { type: String },
    windowInnerHeight: { type: String },
  },

  data() {
    return {
      logo: logo,
      translation: {
        [PRICE_LIST_TYPE_ENUM.default]: "CJENIK / PRICE LIST",
        [PRICE_LIST_TYPE_ENUM.promo]: "PROMO",
      },
    };
  },

  computed: {
    style() {
      return { minHeight: this.windowInnerHeight };
    },
  },

  methods: {
    onSelect(type) {
      this.$emit("select", type);
    },

    translate(option) {
      if (option.label == null || option.label === "") {
        return this.translation[option.type];
      }

      return option.label;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  padding: 0 $size-space-1;
  display: flex;
  flex-direction: column;
}
.home__content {
  flex: 1;
  @media screen and (max-height: 800px) {
    padding: $size-space-1 0 $size-space-1 0;
  }
  @media screen and (min-height: 800px) {
    padding: $size-space-1 0 $size-space-1 0;
  }
}
.home__footer {
  @include animate-float-fade-in(0.2s);
  padding: $size-space-1 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: $color-white;

  .footer-logo {
    margin: 0 auto;
  }
}
.footer-logo {
  width: auto;
  display: block;
  max-width: 100%;
  max-height: 30vh;
  height: auto;
}
.home__client {
  @include animate-float-fade-in;
  @media screen and (max-height: 800px) {
    margin: 0 0 $size-space-2 0;
  }
  @media screen and (min-height: 800px) {
    margin: 0 0 $size-space-3 0;
  }
}
.home__client-title {
  text-align: center;
  font-size: $size-font-4;
  font-weight: 700;
  line-height: 1.25;
  padding: 0 $size-space-1;
  @media screen and (max-height: 800px) {
    margin: $size-space-3 0 $size-space-3 0;
  }
  @media screen and (min-height: 800px) {
    margin: $size-space-4 0 $size-space-4 0;
  }
}
.home__client-image {
  display: block;
  max-width: 100%;
  max-height: 30vh;
  width: auto;
  height: auto;
  margin: 0 auto;
}
.home .home__navigation-items {
  @include animate-float-fade-in(0.1s);
  padding: 0 $size-space-1;
  margin: 0 auto;

  .home__navigation-item {
    margin: $size-space-n1 0;

    & + .home__navigation-item {
      margin-bottom: 0;
    }
  }
}
</style>
